<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4 class="d-flex align-center">
          <v-combobox
            class="width-300 text-xs-left"
            name="bonusProductionType"
            v-validate="'required'"
            :error-messages="errors.collect('select.bonusProductionType')"
            v-model="bonusProductionType"
            :items="items"
            flat
            item-text="title"
            :allow-overflow="false"
            type="button"
            single-line
            return-object
          >
            <template slot="selection" slot-scope="data">
              <div>
                <span style="color:#005cae">{{data.item.title}}</span>
              </div>
            </template>
          </v-combobox>
        <!-- 124840 Tutorial ingreso automático de facturas -->
        <a href="#" @click.prevent="showManualModal = true" style="color: #005cae; text-decoration: none; margin-left: 4rem; font-size: 14px;">
            <v-icon small class="fas fa-hand-point-right mr-1 mb-1"></v-icon>
            Tutorial para ingreso automático de facturas
          </a>
        </v-flex>
        
        <v-dialog v-model="showManualModal" max-width="600px">
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Ingreso automático de Facturas</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showManualModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 380px;">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/ARThFuES_Bc?si=Nf9whtGMulcWZ160" title="Ingreso automático de facturas" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items style="margin-right: 1.5% !important;" v-if="bonusProductionType">
        <v-btn icon title="Visualizar" v-if="false">
          <v-icon color="primary">fa fa-eye</v-icon>
        </v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-left: 5% !important;"
          small
          v-if="bonusProductionType.id==1 && showButtonGenerate"
          @click="sendBonusProductionPreliquidationGeneration"
          color="accent"
        >Generar</v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          v-if="bonusProductionType.id==2  && !bonusProductionPermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusProductionPreliquidationApprove"
          color="accent"
        >Aprobar</v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          v-if="bonusProductionType.id==2  && bonusProductionPermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusProductionPreliquidationApprove"
         
          color="accent"
        >Aprobar</v-btn>
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-right: -1.6% !important;"
          small
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          v-if="bonusProductionType.id==2&&$refs.preAproveList!=null"
          @click="sendBonusProductionPreliquidationReject"
          color="accent"
        >Rechazar</v-btn>
        <v-menu style="margin-left: 4% !important;" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
          class="hidden-xs-only"
               v-if="bonusProductionType.id==2 && bonusProductionPermissionApproveAndBill"
          @click="sendBonusProductionPreliquidationApproveAndBill"
            >
              <v-list-tile-title>Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generateExcel">
              <v-list-tile-title>Generar archivo excel</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generatePDF">
              <v-list-tile-title>Generar archivo pdf</v-list-tile-title>
            </v-list-tile>
            <v-list-tile class="hidden-sm-and-up" v-if="bonusProductionType.id==1 && showButtonGenerate"
            @click="sendBonusProductionPreliquidationGeneration">
              <v-list-tile-title >Generar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusProductionType.id==2  && !bonusProductionPermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusProductionPreliquidationApprove"
            >
              <v-list-tile-title >Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusProductionType.id==2  && bonusProductionPermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusProductionPreliquidationApprove"
            >
              <v-list-tile-title >Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusProductionType.id==2 && bonusProductionPermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusProductionPreliquidationApproveAndBill"
            >
              <v-list-tile-title
                
              >Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              style="height:50%;margin-right: -1.6% !important;"
              small
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusProductionType.id==2&&$refs.preAproveList!=null"
              @click="sendBonusProductionPreliquidationReject"
            >
              <v-list-tile-title >Rechazar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <preliquidation-generation v-if="bonusProductionType && bonusProductionType.id==1"></preliquidation-generation>
    <preliquidation-approval
      ref="preAproveList"
      v-if="bonusProductionType && bonusProductionType.id==2"
    ></preliquidation-approval>
    <liquidation-query ref="liqQuery" v-if="bonusProductionType && bonusProductionType.id==3"></liquidation-query>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { downloadPDF } from "@/common/helpers/helpers";
import { downloadEXCEL } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

import PreliquidationGeneration from "./PreliquidationGeneration.vue";
import PreliquidationApproval from "./PreliquidationApproval.vue";
import LiquidationQuery from "./LiquidationQuery.vue";

export default {
  components: {
    PreliquidationGeneration,
    PreliquidationApproval,
    LiquidationQuery
  },
  computed: {
    ...mapGetters([
      "bonusProductionSelected",
      "bonusProductionPermissionApproveAndBill",
      "bonusProductionPendingPdf",
      "bonusProductionPendingExcel",
      "bonusProductionPdf",
      "bonusProductionExcel",
      "userId",
      "isBrokerBonusProduction"
    ])
  },
  async mounted() {
    this.$store.dispatch("getUserId");
    this.bonusProductionType = this.items[0];
    this.$store.dispatch("bonusProductionPreliquidationValidatePermission");
    await this.$store.dispatch("validateIsUserAgentBonusProduction", this.userId);
    this.showButtonGenerate = this.isBrokerBonusProduction;
  },
  methods: {
    sendBonusProductionPreliquidationGeneration() {
      this.$store
        .dispatch("sendBonusProductionPreliquidationGeneration")
        .then(res => {
          this.$store.dispatch("getBonusProductionPending");
        });
    },
    sendBonusProductionPreliquidationApprove() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusProductionPreliquidationApprove",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar al menos una preliquidación",
          "warning"
        );
      }
    },
    sendBonusProductionPreliquidationApproveAndBill() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch("sendBonusProductionPreliquidationApproveAndBill",this.$refs.preAproveList.selectedValue)
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar al menos una preliquidación",
          "warning"
        );
      }
    },
    sendBonusProductionPreliquidationReject() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusProductionPreliquidationReject",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar al menos una preliquidación",
          "warning"
        );
      }
    },
    generatePDF() {
      
      switch (this.bonusProductionType.id) {
        case 1:
          this.$store.dispatch("getBonusProductionPendingPdf").then(res => {
            if (
              this.bonusProductionPendingPdf.byteLength < 200 ||
              this.bonusProductionPendingPdf.length < 200
            ) {
              this.$root.$emit(
                "showSnackBar",
                "Error generando el pdf", //this.bonusProductionPendingPdf.data,
                "error"
              );
              return;
            }
            downloadPDF(this.bonusProductionPendingPdf, "preliquidaciones.pdf");
          });
          break;

        case 2:
        
          if (this.$refs.preAproveList.selectedValue != null) {
            
            this.$store
              .dispatch(
                "getBonusProduccionPreliminarPdf",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (
                  this.bonusProductionPdf.byteLength < 200 ||
                  this.bonusProductionPdf.length < 200
                ) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el pdf",
                    "error"
                  );
                  return;
                }
                downloadPDF(
                  this.bonusProductionPdf,
                  `bonos-produccion-detalles-${this.$refs.preAproveList.selectedValue}.pdf`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por producción",
              "warning"
            );
          }
          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusProductionPdf",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (
                  this.bonusProductionPdf.byteLength < 200 ||
                  this.bonusProductionPdf.length < 200
                ) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el pdf",
                    "error"
                  );
                  return;
                }
                downloadPDF(
                  this.bonusProductionPdf,
                  `bonos-produccion-detalles-${
                   this.$refs.liqQuery.selectedValue
                  }.pdf`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por producción",
              "warning"
            );
          }
          break;
      }
    },
    generateExcel() {
      switch (this.bonusProductionType.id) {
        case 1:
          this.$store.dispatch("getBonusProductionPendingExcel").then(res => {
            if (
              this.bonusProductionPendingExcel.byteLength < 200 ||
              this.bonusProductionPendingExcel.length < 200
            ) {
              this.$root.$emit(
                "showSnackBar",
                "Error generando el excel", //this.bonusProductionPendingExcel.data,
                "error"
              );
              return;
            } else {
              downloadEXCEL(
                this.bonusProductionPendingExcel,
                "bonos-produccion-pendientes.xlsx"
              );
            }
          });
          break;
        case 2:
          if (this.$refs.preAproveList.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusProductionExcel",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (
                  this.bonusProductionExcel.byteLength < 200 ||
                  this.bonusProductionExcel.length < 200
                ) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el excel", //this.bonusProductionExcel.data,
                    "error"
                  );
                  return;
                }
                downloadEXCEL(
                  this.bonusProductionExcel,
                  `bonos-produccion-detalles-${
                    this.$refs.preAproveList.selectedValue
                  }.xlsx`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por producción",
              "warning"
            );
          }
          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusProductionExcel",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (
                  this.bonusProductionExcel.byteLength < 200 ||
                  this.bonusProductionExcel.length < 200
                ) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el excel", //this.bonusProductionExcel.data,
                    "error"
                  );
                  return;
                }
                downloadEXCEL(
                  this.bonusProductionExcel,
                  `bonos-produccion-detalles-${
                    this.$refs.liqQuery.selectedValue
                  }.xlsx`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por producción",
              "warning"
            );
          }
          break;
      }
    }
  },
  data() {
    return {
      items: [
        {
          id: 1,
          title: i18n.t("message.preliquidationGeneration")
        },
        {
          id: 2,
          title: i18n.t("message.preliquidationApproval")
        },
        {
          id: 3,
          title: i18n.t("message.liquidationQuery")
        }
      ],
      bonusProductionType: undefined,
      showManualModal: false,
      showButtonGenerate: false
    };
  }
};
</script>